import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { addDays, isAfter } from 'date-fns';
import { Badge, BADGE_PRIORITY } from 'wix-ui-tpa/Badge';
import { st, classes } from './StatusBadgeBass.st.css';
import {
  BillingSubscriptionsApiV1Subscription,
  BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus as SubscriptionStatus,
} from '@wix/ambassador-billing-subscriptions/types';

const activeStatuses = [SubscriptionStatus.ACTIVE];

const statusTranslations: Record<SubscriptionStatus, string> = {
  [SubscriptionStatus.UNKNOWN]: 'app.subscription-status.undefined',
  [SubscriptionStatus.DRAFT]: 'app.subscription-status.draft',
  [SubscriptionStatus.PENDING]: 'app.subscription-status.pending',
  [SubscriptionStatus.ACTIVE]: 'app.subscription-status.active',
  [SubscriptionStatus.ENDED]: 'app.subscription-status.expired',
  [SubscriptionStatus.CANCELED]: 'app.subscription-status.canceled',
  // [SubscriptionStatus.PENDING_CANCELLATION]: 'app.subscription-status.pending-cancellation',
  [SubscriptionStatus.PAUSED]: 'app.subscription-status.suspended',
};

const isInFreeTrial = (subscription: BillingSubscriptionsApiV1Subscription) => {
  if (subscription.status === SubscriptionStatus.ACTIVE && subscription.billingSettings?.freeTrialDuration) {
    const freeTrialEnd = subscription.billingStatus?.freeTrialData?.endDate;
    const today = new Date();
    if (freeTrialEnd && isAfter(freeTrialEnd, today)) {
      return true;
    }
  }

  return false;
};

export const getStatusTextTranslationKey = (subscription: BillingSubscriptionsApiV1Subscription) => {
  const inFreeTrial = isInFreeTrial(subscription);
  return inFreeTrial
    ? 'app.subscription-status.free-trial'
    : statusTranslations[subscription.status! as SubscriptionStatus];
};

type Props = {
  subscription: BillingSubscriptionsApiV1Subscription;
};

export const StatusBadgeBass = ({ subscription }: Props) => {
  const { t } = useTranslation();
  const inFreeTrial = isInFreeTrial(subscription);
  const active = inFreeTrial || activeStatuses.indexOf(subscription.status!) > -1;

  return (
    <Badge className={st(classes.root, { active })} priority={BADGE_PRIORITY.default} data-hook="status-badge">
      {t(getStatusTextTranslationKey(subscription))}
    </Badge>
  );
};
